import { FC, ReactNode } from "react";
import { Tabs, Tab, Typography, SxProps } from "@mui/material";
import { Link } from "react-router-dom";
import { getDynamicRoute } from "@/utils/url";
import { black, text } from "@/theme/colors";

export type GenericTabItem = {
  label: string | ReactNode;
  url: string;
};

type GenericTabsProps = {
  tabs: GenericTabItem[];
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  id?: string;
  sx?: SxProps;
  colorBorder?: string;
};

export const GenericTabs: FC<GenericTabsProps> = ({ tabs, value, onChange, id, sx, colorBorder }) => {
  return (
    <Tabs
      value={value}
      onChange={onChange}
      centered
      sx={{
        borderBottom: `4px solid ${colorBorder || black[30]}`,
        marginTop: 1.5,
        "& .MuiTabs-flexContainer": {
          gap: 1,
        },
        "& .MuiTab-root": {
          flex: 1,
          maxWidth: "none",
          backgroundColor: black[95],
          color: text.white,
          borderRadius: "5px 5px 0 0",
        },
        "& .MuiTab-root.Mui-selected": {
          backgroundColor: colorBorder ?? black[30],
        },
        "& .MuiTab-root.Mui-selected .MuiTypography-root": {
          color: text.white,
        },
        "& .MuiTabs-indicator": {
          display: "none",
        },
        ...sx,
      }}
    >
      {tabs.map(({ label, url }) => (
        <Tab
          key={url}
          label={
            typeof label === "string" ? (
              <Typography variant="head20Bold" component="span">
                {label}
              </Typography>
            ) : (
              label
            )
          }
          component={Link}
          to={getDynamicRoute(url, { id })}
        />
      ))}
    </Tabs>
  );
};
